import { ga } from "../lib/google-analytics";

export const trackNavigationClickTypes = {
    MENU_CLICK: "menu_click",
    LOGO_CLICK: "logo_click",
    START_PAGE_PROMO: "start_page_promo",
    BREADCRUMB: "breadcrumb_click",
    PRODUCT_PAGE_ROOM_CLICK: "room_click",
    MOBILE_MENU_CLICK: "mobile_menu_click",
    MOBILE_LOGO_CLICK: "mobile_logo_click",
    MOBILE_START_PAGE_PROMO: "mobile_start_page_promo",
    MOBILE_BREADCRUMB: "mobile_breadcrumb_click",
};

export function trackNavigationClick(type, name, props = {}) {
    ga.addEvent(type, {
        event_category: "Navigation Clicks",
        event_label: name,
        ...props,
    });
}

export const trackProductClickTypes = {
    CATEGORY: "in_category_listing",
    PRODUCT_PAGE_PROMO: "product_page_promo",
    PRODUCT_COLOR: "product_color_click",
    POPULAR_START_PAGE: "product_popular_start_page",
    MOBILE_POPULAR_START_PAGE: "mobile_product_popular_start_page",
    POPULAR_ERROR_PAGE: "product_popular_error_page",
};

export function trackProductClick(type, name, props = {}) {
    ga.addEvent(type, {
        event_category: "Product Clicks",
        event_label: name,
        ...props,
    });
}

/**
 *
 * @param {string} name
 * @param {Record<string, string>} props
 */
export function trackFilterClick(name, props = {}) {
    ga.addEvent("category_filter_click", {
        event_category: "Category Product Filter Clicks",
        event_label: name,
        ...props,
    });
}
